import React, { useEffect, useState } from "react";
import api from "@/lib/api";

// Single shared source for the public contact email (from /content/settings).
export function useContactEmail() {
  const [email, setEmail] = useState("info@thedsocialhouses.com");
  useEffect(() => {
    api.get("/content/settings").then((r) => r.data?.public_contact_email && setEmail(r.data.public_contact_email)).catch(() => {});
  }, []);
  return email;
}

export function ContactLine({ className = "text-gold hover:underline" }) {
  const email = useContactEmail();
  return <a href={`mailto:${email}`} className={className} data-testid="contact-email-link">{email}</a>;
}
